.dialogContent {
    font-size: 1rem;
}
